export default {
  "recent_activity":"Actividad reciente",
  "you_have_unfinished_invoice":"Tienes una factura sin terminar",
  "you_have_unfinished_estimate":"Tienes un presupuesto sin terminar",
  "invoice":"Factura",
  "estimate":"Presupuesto",
  "home":"Inicio",
  "document":"Documento",
  "client":"Cliente",
  "report":"Informe",
  "new":"Nuevo",
  "no_client_found":"No se encontró ningún cliente.",
  "search":"Buscar",
  "clients":"Clientes",
  "documents":"Documentos",
  "no_document_found":"No se encontró ningún documento.",
  "cancel":"Cancelar",
  "new_client":"Nuevo cliente",
  "add_client":"Añadir cliente",
  "client_name_is_required":"¡El nombre del cliente es obligatorio!",
  "client_name":"Nombre del cliente",
  "email":"Correo electrónico",
  "phone":"Teléfono",
  "mobile":"Móvil",
  "fax":"Fax",
  "address":"Dirección",
  "address_1":"Dirección 1",
  "address_2":"Dirección 2",
  "city":"Ciudad",
  "state_province":"Provincia/Estado",
  "zip_postal_code":"Código postal",
  "country":"País",
  "filter_documents":"Filtrar documentos",
  "apply_filter":"Aplicar filtro",
  "document_type":"Tipo de documento",
  "all":"Todos",
  "send_state":"Estado de envío",
  "sent":"Enviado",
  "not_sent":"No enviado",
  "payment_state":"Estado de pago",
  "paid":"Pagado",
  "not_paid":"No pagado",
  "overdue":"Vencido",
  "date":"Fecha",
  "this_month":"Este mes",
  "this_year":"Este año",
  "custom":"Personalizado",
  "from":"Desde",
  "to":"Hasta",
  "preview":"Vista previa",
  "summary":"Resumen",
  "estimate_number":"Número de presupuesto",
  "issued":"Emitido",
  "valid_until":"Válido hasta",
  "history":"Historial",
  "show":"Mostrar",
  "share":"Compartir",
  "print":"Imprimir",
  "download_pdf":"Descargar PDF",
  "send_estimate":"Enviar presupuesto",
  "document_history":"Historial de documentos",
  "mark_as_paid":"Marcar como pagado",
  "paid":"Pagado",
  "invoice_number":"Número de factura",
  "due":"Vencimiento",
  "send_invoice":"Enviar factura",
  "new_item":"Nuevo artículo",
  "name":"Nombre",
  "price":"Precio",
  "item_name":"Nombre del artículo",
  "item_price":"Precio del artículo",
  "item_name_is_required":"¡El nombre del artículo es obligatorio!",
  "item_price_is_required":"¡El precio del artículo es obligatorio!",
  "item_tax_state":"Estado fiscal del artículo",
  "add_item":"Añadir artículo",
  "new_service":"Nuevo servicio",
  "unit":"Unidad (hora, día)",
  "service_name_is_required":"¡El nombre del servicio es obligatorio!",
  "service_price_is_required":"¡El precio del servicio es obligatorio!",
  "tax":"Impuesto",
  "service_tax_state":"Estado fiscal del servicio",
  "add_service":"Añadir servicio",
  "items_and_services":"Artículos y servicios",
  "items":"Artículos",
  "item":"Artículo",
  "services":"Servicios",
  "update_item":"Actualizar artículo",
  "are_you_sure":"¿Estás seguro?",
  "this_action_will_delete_the_item":"Esta acción eliminará el artículo.",
  "delete":"Eliminar",
  "update":"Actualizar",
  "update_service":"Actualizar servicio",
  "this_action_will_delete_the_service":"Esta acción eliminará el servicio.",
  "business":"Empresa",
  "business_details":"Detalles de la empresa",
  "business_details_1":"Detalles de la empresa",
  "business_logo":"Logo de la empresa",
  "business_name":"Nombre de la empresa",
  "business_name_is_required":"¡El nombre de la empresa es obligatorio!",
  "mobile_number":"Número de móvil",
  "mobile_number_2":"Número de móvil 2",
  "website":"Sitio web",
  "street":"Calle",
  "street_2":"Calle 2",
  "save":"Guardar",
  "settings":"Configuración",
  "business_settings":"Configuración de la empresa",
  "payment_options":"Opciones de pago",
  "tax_settings":"Configuración de impuestos",
  "document_settings":"Configuración de documentos",
  "template_design_and_settings":"Diseño y configuración de plantillas",
  "app_settings":"Configuración de la aplicación",
  "language":"Idioma",
  "theme":"Tema",
  "dark":"Oscuro",
  "light":"Claro",
  "auto":"Automático",
  "subscription":"Suscripción",
  "rate_us":"Califícanos",
  "paypal_email_is_required":"El correo de PayPal es obligatorio",
  "online_payments":"Pagos en línea",
  "paypal":"PayPal",
  "paypal_email":"Correo de PayPal",
  "stripe":"Stripe",
  "payment_instructions":"Instrucciones de pago",
  "add_instructions":"Agrega instrucciones para recibir el pago:\n- Información de cuenta bancaria.\n- Venmo, Zelle, Cash App.\n- Otros detalles.",
  "apply_tax_to_documents":"Aplicar impuestos a los documentos",
  "tax_label":"Etiqueta del impuesto",
  "option_1":"Opción 1 (%)",
  "option_2":"Opción 2 (%)",
  "option_3":"Opción 3 (%)",
  "itemsandservices":"Artículos&Servicios",
  "preview_and_customize":"Vista previa y personalizar",
  "new_estimate":"Nuevo presupuesto",
  "add_itemandservice":"Añadir artículo/servicio",
  "sub-total":"Subtotal",
  "discount":"Descuento",
  "total":"Total",
  "estimate_notes":"Notas del presupuesto",
  "create_estimate":"Crear presupuesto",
  "new_invoice":"Nueva factura",
  "invoice_notes":"Notas de la factura",
  "create_invoice":"Crear factura",
  "client_details":"Detalles del cliente",
  "save_changes":"Guardar cambios",
  "remove_this_client_from_the_document":"¡Eliminar este cliente del documento!",
  "contact":"Contacto",
  "update_invoice":"Actualizar factura",
  "item_details":"Detalles del artículo",
  "remove_this_item_from_the_document":"¡Eliminar este artículo del documento!",
  "quantity":"Cantidad",
  "item_quantity_is_required!":"¡La cantidad del artículo es obligatoria!",
  "total_price":"Precio total",
  "service_details":"Detalles del servicio",
  "remove_this_service_from_the_document":"¡Eliminar este servicio del documento!",
  "unit_type":"Tipo de unidad",
  "service_quantity_is_required":"La cantidad del servicio es obligatoria",
  "select_terms":"Seleccionar condiciones",
  "taxable":"Sujeto a impuestos",
  "non_taxable":"No sujeto a impuestos",
  "total_estimates":"Total de presupuestos",
  "total_invoices":"Total de facturas",
  "service_name":"Nombre del servicio",
  "service_price":"Precio del servicio",
  "no_item_found":"No se encontró ningún artículo.",
  "no_service_found":"No se encontró ningún servicio.",
  "select_your_language":"Selecciona tu idioma",
  "stripe_invoice_link":"Enlace de factura Stripe",
  "update_estimate":"Actualizar presupuesto",
  "sub_total":"Subtotal",
  "select_a_currency":"Seleccionar moneda",
  "reports":"Informes",
  "customize":"Personalizar",
  "edit":"Editar",
  "invoices":"Facturas",
  "estimates":"Presupuestos",
  "get_statement":"Obtener estado de cuenta",
  "no_client_found_with_the_given_id":"No se encontró un cliente con el ID dado.",
  "no_statement_found":"No se encontró ningún estado de cuenta",
  "no_document_found_for_this_client":"No se encontró ningún documento para este cliente.",
  "client_statment":"Estado de cuenta del cliente",
  "send_statment":"Enviar estado de cuenta",
  "update_client":"Actualizar cliente",
  "remove_this_item":"Eliminar este artículo",
  "remove_this_service":"Eliminar este servicio",
  "set_as_default":"Establecer como predeterminado",
  "top_invoiced_clients":"CLIENTES MÁS FACTURADOS",
  "amount":"Monto",
  "invoices_up":"FACTURAS",
  "quarter":"Trimestre",
  "unpaid":"No pagado",
  "top_invoiced_items":"ARTÍCULOS MÁS FACTURADOS",
  "quantity_up":"Cantidad",
  "top_invoiced_services":"SERVICIOS MÁS FACTURADOS",
  "last_year":"El año pasado",
  "life_time":"De por vida",
  "ok":"OK",
  "invoice_send_template_subject":"Factura #{document_number} de {business_name}",
  "invoice_send_template_email":"Hola {client_name},\n \nEspero que estés bien.\n \nHemos generado una nueva factura (#{document_number}) de {business_name}.\n \nPuedes verla o descargarla de forma segura en el siguiente enlace:\n \n🔗 https://snapbill.app/document/{document_id}\n \nSi tienes preguntas sobre esta factura o necesitas ayuda, no dudes en contactarnos en {business_email}.\n \nGracias por confiar en {business_name}.\n \n¡Valoramos mucho tu colaboración!\n \nAtentamente,\n \nEl equipo de {business_name}",
  "estimate_send_template_subject":"Presupuesto #{document_number} de {business_name}",
  "estimate_send_template_email":"Hola {client_name},\n \nEspero que estés bien.\n \nHemos preparado un presupuesto (#{document_number}) de {business_name} para ti.\n \nPuedes verlo o descargarlo de forma segura en el siguiente enlace:\n \n🔗 https://snapbill.app/document/{document_id}\n \nSi tienes preguntas, deseas ajustes o quieres proceder, responde a este correo o contáctanos en {business_email}.\n \nGracias por tu interés en {business_name}.\n \n¡Esperamos trabajar contigo!\n \nAtentamente,\n \nEl equipo de {business_name}",
  "statement_send_template_subject":"Estado de cuenta de {business_name}",
  "statement_send_template_email":"Hola {client_name},\n \nEspero que estés bien.\n \nTu estado de cuenta actual de {business_name} ya está disponible.\nEste estado incluye un resumen de tus facturas y presupuestos.\n \nPuedes verlo o descargarlo de forma segura en el siguiente enlace:\n \n🔗 https://snapbill.app/statement/{statment_number}\n \nSi tienes preguntas sobre este estado de cuenta o necesitas más detalles, no dudes en contactarnos en {business_email}.\n \nGracias por confiar en {business_name}.\n \nAtentamente,\n \nEl equipo de {business_name}",
  "no_internet_connection":"Sin conexión a Internet",
  "you_need_an_internet_connection_to_send_or_share_your_invoice":"Necesitas una conexión a Internet para enviar o compartir tu factura.\nPor favor, comprueba tu conexión e inténtalo de nuevo, o elige una de las opciones sin conexión (imprimir o descargar como PDF) para continuar.",
  "you_need_an_internet_connection_to_send_or_share_your_estimate":"Necesitas una conexión a Internet para enviar o compartir tu presupuesto.\nPor favor, comprueba tu conexión e inténtalo de nuevo, o elige una de las opciones sin conexión (imprimir o descargar como PDF) para continuar.",
  "you_need_an_internet_connection_to_send_or_share_your_statment":"Necesitas una conexión a Internet para enviar o compartir tu estado de cuenta.\nPor favor, comprueba tu conexión e inténtalo de nuevo, o elige una de las opciones sin conexión (imprimir o descargar como PDF) para continuar.",
  "error":"Error",
  "mail_composer_is_not_available_on_this_device":"El editor de correo no está disponible en este dispositivo",
  "estimate_full_capital":"PRESUPUESTO",
  "invoice_full_capital":"FACTURA",
  "estimate_to":"PRESUPUESTO A",
  "invoice_to":"FACTURA A",
  "invoice_no":"N.º de factura:",
  "issue_date":"Fecha de emisión:",
  "due_date":"Fecha de vencimiento:",
  "valid_until":"Válido hasta:",
  "description":"Descripción",
  "unit_price":"Precio unitario",
  "note":"Nota:",
  "number_1":"Número 1",
  "number_2":"Número 2",
  "bill_to":"Facturar a",
  "from_full_capital":"DE",
  "details_full_capital":"DETALLES",
  "valid": "Válido",
  "select_contact": "Seleccionar contacto",
  "no_contacts": "No se encontraron contactos",
  "import_from_contacts": "Importar desde contactos",
  "call": "Llamar",
  "message": "Mensaje",
  "success": "Éxito",
  "pdf_saved": "¡PDF guardado! Abre Archivos → En mi iPhone → SnapBill",
  "not_send": "No enviado",
  "created": "Creado",
  "send_to": "Enviar a",
  "signatures": "Firmas",
  "signature": "Firma",
  "new_signature": "Nueva firma",
  "signature_name_is_required": "El nombre de la firma es obligatorio",
  "clear": "Borrar",
  "delete_signature": "Eliminar firma",
  "this_action_will_delete_the_signature": "Esta acción eliminará la firma.",
  "no_signatures_found": "No se encontraron firmas",
  "add_your_signature": "Agrega tu firma",
  "this_action_will_remove_the_signature_from_this_document": "Esta acción eliminará la firma de este documento.",
  "on_receipt": "Al recibir",
  "three_days": "3 días",
  "ten_days": "10 días",
  "thirty_days": "30 días",
  "no_duo_date": "Sin fecha de vencimiento",
  "no_valid_date": "Sin fecha válida",
  "select_date": "Seleccionar fecha",
  "percentage": "Porcentaje",
  "fix": "Fijo",
  "please_add_client_detail_to_the_invoice": "Por favor, añade los datos del cliente a la factura",
  "please_add_at_least_one_item_to_the_invoice": "Por favor, añade al menos un artículo a la factura",
  "please_add_client_detail_to_the_estimate": "Por favor, añade los datos del cliente al presupuesto",
  "please_add_at_least_one_item_to_the_estimate": "Por favor, añade al menos un artículo al presupuesto",
  "next": "Siguiente",
  "get_started": "Empezar",
  "create_invoices_and_estimates_in_seconds": "Crea facturas y presupuestos en segundos",
  "auto_fill_client_details": "Rellena automáticamente los datos del cliente, aplica plantillas y envía en menos de 20 segundos.",
  "get_paid_faster_and_know_it_instantly": "Cobra más rápido y entérate al instante",
  "snapbill_notifies_you_the_moment": "SnapBill te avisa en el momento en que tus clientes abren la factura o inician el pago. Nada de adivinanzas, solo actualizaciones en tiempo real y un flujo de caja más rápido.",
  "see_your_business_in_full_color": "Ve tu negocio a todo color",
  "visualize_income_trends": "Visualiza las tendencias de ingresos, controla las facturas vencidas y detecta a tus mejores clientes, todo con informes claros e inteligentes que te ayudan a crecer con confianza.",
  "unlimited_access": "Acceso ilimitado",
  "not_sure_yet": "¿Aún no estás seguro?",
  "enable_free_access": "Activar acceso gratuito",
  "best_offer": "Mejor oferta",
  "yearly_plan": "Plan anual",
  "per_week": "por semana",
  "three_days_free_trail": "3 días de prueba gratis",
  "weekly_plan": "Plan semanal",
  "countinue_with_three_days_free": "Continuar con 3 días gratis",
  "countinue_with_best_offer": "Continuar con la mejor oferta",
  "privacy": "Privacidad",
  "already_subscribed": "¿Ya estás suscrito?",
  "terms": "Términos",
  "please_select_different_plan": "Por favor, selecciona un plan diferente",
  "your_current_plan": "Tu plan actual",
  "statment_of_account": "Estado de cuenta",
  "statment_date": "Fecha del estado",
  "classic": "Clásico",
  "modern": "Moderno",
  "wave": "Wave",
  "estimate_no": "Presupuesto Nº:",
  "pay_now":"Pagar ahora",
  "copy":"Copiar",
  "copied":"Copiado",
  "invalid_stripe_invoice_link":"Enlace de factura de Stripe no válido",
  "client_name_viewed_your_invoice_document_number":"{client_name} ha visto tu factura n.º {document_number}",
  "client_name_viewed_your_estimate_document_number":"{client_name} ha visto tu presupuesto n.º {document_number}",
  "client_name_started_paying_invoice":"{client_name} empezó a pagar la factura n.º {document_number} mediante {payment_method}",
  "good_news":"¡Buenas noticias!"
} 